module.exports = __webpack_public_path__ + "static/img/magicBayGiftbg.11fb73c.png";